import React from "react";

const CatalogoSimulado3D = () => {
  const imagens = [
    "/catalogo-simulado/catalogo-1.jpg",
    "/catalogo-simulado/catalogo-2.jpg",
    "/catalogo-simulado/catalogo-3.jpg",
    "/catalogo-simulado/catalogo-4.jpg",
    "/catalogo-simulado/catalogo-5.jpg",
    "/catalogo-simulado/catalogo-6.jpg",
    "/catalogo-simulado/catalogo-7.jpg",
    "/catalogo-simulado/catalogo-8.jpg",
    "/catalogo-simulado/catalogo-9.jpg",
    "/catalogo-simulado/catalogo-10.jpg",
    "/catalogo-simulado/catalogo-11.jpg",
    "/catalogo-simulado/catalogo-12.jpg",
    "/catalogo-simulado/catalogo-13.jpg",
    "/catalogo-simulado/catalogo-14.jpg",
    "/catalogo-simulado/catalogo-15.jpg",
    "/catalogo-simulado/catalogo-16.jpg",
  ];

  // Duplicar as imagens para criar um loop contínuo (3x para melhor transição)
  const duplicatedImages = [...imagens, ...imagens, ...imagens];

  // Divida as imagens em colunas
  const colunas = [[], [], [], []];
  duplicatedImages.forEach((img, idx) => {
    colunas[idx % 4].push(img);
  });

  return (
    <div className="relative w-full max-w-[1100px] sm:max-w-[1400px] mx-auto h-[50vh] sm:h-[50vh] md:h-[50vh] lg:h-[80vh] xl:h-[90vh] px-2 sm:px-4">
      {/* Definindo as animações e estilos */}
      <style jsx>{`
        @keyframes scroll-up {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(-33.33%);
          }
        }
        @keyframes scroll-down {
          0% {
            transform: translateY(-33.33%);
          }
          100% {
            transform: translateY(0);
          }
        }
        .perspective-container {
          perspective: 1200px;
          transform-style: preserve-3d;
        }
        .grid-3d {
          transform-style: preserve-3d;
          transform: rotateX(20deg) rotateY(10deg) rotateZ(-3deg);
        }
        .card-clip {
          clip-path: inset(0 0 0 0 round 1rem);
        }
      `}</style>

      {/* Card principal */}
      <div className="absolute inset-0 bg-white rounded-xl shadow-lg card-clip overflow-hidden">
        <div className="perspective-container w-full h-full">
          <div className="grid-3d grid grid-cols-4 h-full w-full gap-3 p-4">
            {colunas.map((coluna, idx) => (
              <div
                key={idx}
                className={`flex flex-col gap-3 ${
                  idx % 2 === 0 ? "animate-scroll-up" : "animate-scroll-down"
                }`}
                style={{
                  animation: `${idx % 2 === 0 ? "scroll-up" : "scroll-down"} ${
                    90 + idx * 5 // Animação bem mais lenta
                  }s linear infinite`,
                }}
              >
                {coluna.map((img, i) => (
                  <div
                    key={i}
                    className="relative group"
                    style={{
                      transformStyle: "preserve-3d",
                    }}
                  >
                    <div className="aspect-[4/5] overflow-hidden rounded-lg shadow-sm bg-gray-50">
                      <img
                        src={img}
                        alt={`Produto ${i}`}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        style={{
                          transform: "translateZ(30px)",
                          backfaceVisibility: "hidden",
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CatalogoSimulado3D;
